export enum AssessmentCategoryEnums {
  PRIMATOO = 'PRIMATOO',
  SUPPLIER = 'SUPPLIER',
  INTERNAL = 'INTERNAL',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  NOT_SUPPORTED = 'NOT_SUPPORTED'
  //custom use on application create/update
  // UNAVAILABLE = 'UNAVAILABLE',
  // UNSUPPORTED = 'UNSUPPORTED'

}
